'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('app-config-editor', {
      url: '/admin/app-config-editor',
      template: '<app-config-editor></app-config-editor>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/app-config/app-config.routes.js